import eventBus from 'toxilibs/event_bus_queued.js'
import getStepsWithDependencies from './core/step_dependencies.js'
import getUrlParams from 'toxilibs/url_params.js'
import themes from './themes.js'



//FIXME overridingVars goes with variables
//FIXME testOrAffectation goes with booleans ?



const {challenge, theme = 'basic_coding'} = getUrlParams()
const steps = themes[theme] || themes.basic_coding
let noDependencies = false

let wantedSteps
let acquiredSteps

if (challenge) {
    setOneLevelSteps(challenge)
} else {
    setSteps()
}


function setSteps () {
    if (steps.wanted) {
        wantedSteps   = steps.wanted
        acquiredSteps = steps.acquired
    } else {
        wantedSteps = steps
    }
}


function setOneLevelSteps (levelName) {
    const path = levelPath(levelName)
    if (path) {
        wantedSteps = [path]
        noDependencies = true
    } else {
        console.error('Challenge ' + challenge + ' not found')
        setSteps()
    }
}


function levelPath (levelName) {
    for (let themeName in themes) {
        let themeSteps = themes[themeName]
        if (themeSteps.wanted) {
            themeSteps = themeSteps.wanted
        }
        for (let i = 0; i < themeSteps.length; i++) {
            const stepPath = themeSteps[i].split('/')
            if (stepPath[stepPath.length - 1] === levelName) {
                return themeSteps[i]
            }
        }
    }
    return null
}


eventBus.on('page loaded', function () {
    getStepsWithDependencies({
        wantedStepPaths:   wantedSteps,
        acquiredStepPaths: acquiredSteps,
        noDependencies,
        callback: function (stepsWithDependencies) {
            setLevelsLanguage(stepsWithDependencies)
            eventBus.emit('levels loaded', stepsWithDependencies)
        }
    })
})


function setLevelsLanguage (levels) {
    for (let i = 0; i < levels.length; i++) {
        levels[i].language = steps.language
    }
}



